/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Copy_Id_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to copy ID: {error}" |
*
* @param {Explorer_Info_Copy_Id_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_failed_toast = /** @type {((inputs: Explorer_Info_Copy_Id_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la copie de l'ID : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Kopieren der ID: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile copiare l'ID: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось скопировать ID: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo copiar el ID: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`复制 ID 失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`IDのコピーに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आईडी ${i?.error} कॉपी करने में विफल`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao copiar o ID: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to copy ID: ${i?.error}`)
});